import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Text from '../Text'
import Loading from '../Loading'
import Table from '../Table'

export const GET_BEACONS = gql`
  {
    beacons {
      id
      tag
      model {
        id
        name
        manufacturer {
          id
          name
        }
      }
      owner {
        id
        firstName
        lastName
      }
      assignee {
        id
        firstName
        lastName
      }
    }
  }
`

const columns = [
  {Header: 'Tag', accessor: 'tag'},
  {Header: 'Model', accessor: 'model.name'},
  {Header: 'Manufacturer', accessor: 'model.manufacturer.name'},
  {id: 'owner', Header: 'Owner', accessor: ({owner}) => owner && `${owner.firstName} ${owner.lastName}`},
  {id: 'assignee', Header: 'Assignee', accessor: ({assignee}) => assignee && `${assignee.firstName} ${assignee.lastName}`}
]

const List = ({onRowClick, filterable}) =>
  <Query query={GET_BEACONS} fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (error) return <Text error>{error.message}</Text>

      return (
        <React.Fragment>
          {loading && <Loading />}
          <Table
            filterable={filterable}
            noDataText={!loading && 'No beacons found!'}
            loading={loading}
            data={data.beacons}
            columns={columns}
            onRowClick={onRowClick}
          />
        </React.Fragment>
      )
    }}
  </Query>

export default List


// WEBPACK FOOTER //
// ./src/components/Beacons/List.js